function customizePasswordInputs(form) {
	const buttons = form.querySelectorAll('[data-form="passwordToggle"]');

	buttons.forEach(button => {
		var field = button.parentNode.querySelector('input');

		button.addEventListener('click', () => {
			var isPressed = field.getAttribute('type') !== 'password';

			field.setAttribute('type', isPressed ? 'password' : 'text');
			button.setAttribute('aria-pressed', isPressed ? 'false' : 'true');
		});
	});
}

export { customizePasswordInputs };
